/**
 * Height Finder - Shopify facets
 *
 * Palautettu “alkuperäinen” rakenne:
 *  - stopImmediatePropagation näkyvälle inputille (ei facet re-renderiä kirjoittaessa)
 *  - piilotettu input facets-formiin
 *  - sessionStorage + URL-check arvojen liimaamiseen
 *  - opSeq "viimeisin voittaa" async päivityksissä
 *
 * Muutos:
 *  - EI auto-apply / EI auto-clear kirjoituksesta
 *  - Päivitys tapahtuu vain “Käytä”-napista
 */

(() => {
  if (window.__HeightFinderPituuslistaInitialized) return;
  window.__HeightFinderPituuslistaInitialized = true;

  const FILTER_PARAM = 'filter.p.m.custom.pituuslista';
  const MIN_ALLOWED = 100;
  const MAX_ALLOWED = 220;

  const AUTO_APPLY_DIGITS = 3;

  const UPDATE_TIMEOUT = 2500;
  const STORAGE_KEY = 'velo_height_finder_pituuslista';

  let opSeq = 0;

  // undefined = ei kesken, number/null = kesken oleva tavoitetila (lukitsee UI:n)
  let pendingValue = undefined;

  function $(id) {
    return document.getElementById(id);
  }

  function escapeRegex(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function getFacetRoot() {
    return document.getElementById('facet-filters') || document.querySelector('facet-filters');
  }

  function getFiltersContainer() {
    const root = getFacetRoot();
    return root ? root.querySelector('.facets__filters') : null;
  }

  function getForm() {
    return document.getElementById('facets') || document.querySelector('form#facets');
  }

  function urlHasHeightParam() {
    const qs = window.location.search || '';
    return (
      qs.includes(FILTER_PARAM) ||
      qs.includes(`${FILTER_PARAM}%5B%5D`) ||
      qs.includes(encodeURIComponent(FILTER_PARAM))
    );
  }

  // Robust: tukee myös filter.p...%5B%5D=187
  function getUrlHeight() {
    const qs = window.location.search || '';
    if (!qs) return null;

    const re = new RegExp(
      `(?:[?&])${escapeRegex(FILTER_PARAM)}(?:%5B%5D)?=([^&]+)`,
      'i'
    );
    const m = qs.match(re);
    if (!m) return null;

    let raw = m[1] || '';
    try {
      raw = decodeURIComponent(raw.replace(/\+/g, '%20'));
    } catch (_) {}

    const height = parseInt(raw, 10);
    if (Number.isNaN(height)) return null;
    if (height < MIN_ALLOWED || height > MAX_ALLOWED) return null;

    return height;
  }

  /**
   * IMPORTANT:
   *  - Piilotetun inputin pitää olla `.facets__filters` sisällä, jotta teeman facet-engine
   *    varmasti kerää sen FormDataan.
   */
  function ensureHiddenInput() {
    const form = getForm();
    if (!form) return null;

    const filtersHost = getFiltersContainer() || form;

    let hidden =
      form.querySelector('#height-filter-hidden') ||
      form.querySelector(`input[type="hidden"][name="${FILTER_PARAM}"]`);

    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.id = 'height-filter-hidden';
      hidden.name = FILTER_PARAM;
      hidden.value = '';
      hidden.disabled = true;
    } else {
      hidden.id = hidden.id || 'height-filter-hidden';
      hidden.name = FILTER_PARAM;
    }

    if (filtersHost && !filtersHost.contains(hidden)) {
      filtersHost.prepend(hidden);
    }

    return hidden;
  }

  function setHidden(heightOrNull) {
    const hidden = ensureHiddenInput();
    if (!hidden) return;

    if (typeof heightOrNull === 'number') {
      hidden.value = String(heightOrNull);
      hidden.disabled = false;
    } else {
      hidden.value = '';
      hidden.disabled = true;
    }
  }

  function getHiddenHeight() {
    const hidden = ensureHiddenInput();
    if (!hidden || hidden.disabled) return null;

    const h = parseInt(String(hidden.value || ''), 10);
    if (Number.isNaN(h)) return null;
    if (h < MIN_ALLOWED || h > MAX_ALLOWED) return null;

    return h;
  }

  function setStored(heightOrNull) {
    try {
      if (typeof heightOrNull === 'number') sessionStorage.setItem(STORAGE_KEY, String(heightOrNull));
      else sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  function getStoredHeight() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      const h = parseInt(raw, 10);
      if (Number.isNaN(h)) return null;
      if (h < MIN_ALLOWED || h > MAX_ALLOWED) return null;
      return h;
    } catch (_) {
      return null;
    }
  }

  function showClearButton(show) {
    const clearBtn = $('height-finder-clear');
    if (!clearBtn) return;
    clearBtn.hidden = !show;
  }

  function clearError() {
    const errorEl = $('height-finder-error');
    if (errorEl) errorEl.remove();
    const input = $('height-finder-input');
    if (input) input.classList.remove('input--error');
  }

  function showError(message) {
    clearError();

    const input = $('height-finder-input');
    if (!input) return;

    const errorEl = document.createElement('p');
    errorEl.id = 'height-finder-error';
    errorEl.className = 'height-finder__error text-sm mt-2';
    errorEl.textContent = message;
    errorEl.setAttribute('role', 'alert');

    input.classList.add('input--error');

    const inputWrapper = input.closest('.height-finder__input-wrapper');
    if (inputWrapper) inputWrapper.insertAdjacentElement('afterend', errorEl);

    input.focus();
  }

  function ensureStyles() {
    const STYLE_ID = 'height-finder-autoapply-style';
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      #height-finder .height-finder__input-wrapper{
        display:flex;
        align-items:center;
        gap:10px;
      }
      #height-finder #height-finder-input{
        flex: 1 1 auto;
        width:100%;
        min-width:0;
      }
      #height-finder #height-finder-apply{
        flex: 0 0 auto;
        white-space: nowrap;
      }
    `;
    document.head.appendChild(style);
  }

  function sanitizeDigits(raw) {
    let digits = String(raw || '').replace(/[^\d]/g, '');
    if (digits.length > AUTO_APPLY_DIGITS) digits = digits.slice(0, AUTO_APPLY_DIGITS);
    return digits;
  }

  function ensureApplyButton() {
    const input = $('height-finder-input');
    if (!input) return null;

    const wrapper = input.closest('.height-finder__input-wrapper');

    let btn = $('height-finder-apply');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.id = 'height-finder-apply';
      btn.textContent = 'Käytä';

      // Yritetään käyttää teeman button-luokkia, mutta ei pakoteta (toimii ilmankin)
      btn.className = 'button button--primary';
      btn.setAttribute('aria-label', 'Käytä pituusfiltteri');

      if (wrapper) wrapper.appendChild(btn);
      else input.insertAdjacentElement('afterend', btn);
    }

    if (!btn.__veloHeightFinderApplyBound) {
      btn.__veloHeightFinderApplyBound = true;
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        applyHeight();
      });
    }

    return btn;
  }

  function setApplyButtonDisabled(disabled) {
    const btn = ensureApplyButton();
    if (!btn) return;
    btn.disabled = !!disabled;
  }

  function updateApplyButtonState() {
    const input = $('height-finder-input');
    if (!input) return;

    // päivitys kesken -> ei uutta applyä
    if (pendingValue !== undefined) {
      setApplyButtonDisabled(true);
      return;
    }

    const digits = sanitizeDigits(input.value);
    if (digits.length !== AUTO_APPLY_DIGITS) {
      setApplyButtonDisabled(true);
      return;
    }

    const height = parseInt(digits, 10);
    if (Number.isNaN(height) || height < MIN_ALLOWED || height > MAX_ALLOWED) {
      setApplyButtonDisabled(true);
      return;
    }

    // jos sama kuin nykyinen applied, voidaan halutessa disablettää
    const currentApplied = getEffectiveHeight();
    if (typeof currentApplied === 'number' && currentApplied === height) {
      setApplyButtonDisabled(true);
      return;
    }

    setApplyButtonDisabled(false);
  }

  /**
   * CRITICAL:
   *  - Estetään näkyvän inputin eventit facet-engineen (muuten teema re-renderöi heti ja nollaa kentän).
   *  - Kirjoitus ei applaa mitään; vain sanitointi + napin enable/disable.
   */
  function bindHeightInputGuards() {
    const input = $('height-finder-input');
    if (!input) return;

    if (input.__veloHeightFinderBound) return;
    input.__veloHeightFinderBound = true;

    const stopToFacets = (e) => {
      e.stopImmediatePropagation();
      e.stopPropagation();
    };

    input.addEventListener(
      'input',
      (e) => {
        stopToFacets(e);
        clearError();

        const digits = sanitizeDigits(input.value);
        if (digits !== input.value) input.value = digits;

        // ei auto-clear / ei auto-apply
        updateApplyButtonState();
      },
      true
    );

    input.addEventListener(
      'keydown',
      (e) => {
        stopToFacets(e);

        if (e.key === 'Enter') {
          // Estä form submit (ja teeman mahdolliset Enter-kuuntelijat)
          e.preventDefault();

          // Päivitä nappitila ja klikkaa "Käytä" jos se on aktiivinen
          updateApplyButtonState();
          const btn = ensureApplyButton();

          if (btn && !btn.disabled) {
            btn.click(); // -> kutsuu applyHeight() saman reitin kautta kuin hiiriklikkaus
          }
        }
      },
      true
    );
  }

  /**
   * Triggeröi teeman facet-engine:
   *  - dispatch event piilotetulta inputilta -> event.target on “oikea” input
   */
  function triggerFacetsAjaxRefresh() {
    const filtersEl = getFiltersContainer();
    const hidden = ensureHiddenInput();
    if (!filtersEl || !hidden) return false;

    try {
      hidden.dispatchEvent(new Event('input', { bubbles: true }));
      hidden.dispatchEvent(new Event('change', { bubbles: true }));
      // varotoimi: myös containerille
      filtersEl.dispatchEvent(new Event('input', { bubbles: true }));
      return true;
    } catch (_) {
      return false;
    }
  }

  function fallbackNavigateTo(heightOrNull) {
    const url = new URL(window.location.href);

    if (typeof heightOrNull === 'number') url.searchParams.set(FILTER_PARAM, String(heightOrNull));
    else url.searchParams.delete(FILTER_PARAM);

    url.searchParams.delete('page');
    window.location.assign(url.toString());
  }

  function urlMatchesExpected(expectedValueOrNull) {
    const qs = window.location.search || '';
    if (typeof expectedValueOrNull === 'number') {
      return qs.includes(`${FILTER_PARAM}=${expectedValueOrNull}`) || (getUrlHeight() === expectedValueOrNull);
    }
    // clear
    return !urlHasHeightParam();
  }

  function waitForFacetUpdate(timeoutMs = UPDATE_TIMEOUT) {
    return new Promise((resolve) => {
      let done = false;

      const onUpdated = () => {
        if (done) return;
        done = true;
        resolve(true);
      };

      document.addEventListener('on:facet-filters:updated', onUpdated, { once: true });

      setTimeout(() => {
        if (done) return;
        done = true;
        document.removeEventListener('on:facet-filters:updated', onUpdated);
        resolve(false);
      }, timeoutMs);
    });
  }

  function stickySetVisibleValue(valueOrNull) {
    const input = $('height-finder-input');
    if (!input) return;

    const v = (typeof valueOrNull === 'number') ? String(valueOrNull) : '';
    if (input.value !== v) input.value = v;

    requestAnimationFrame(() => {
      const i = $('height-finder-input');
      if (i && i.value !== v) i.value = v;
    });

    setTimeout(() => {
      const i = $('height-finder-input');
      if (i && i.value !== v) i.value = v;
    }, 50);
  }

  function getEffectiveHeight() {
    // 1) pending lukitsee UI:n
    if (pendingValue !== undefined) return pendingValue;

    // 2) URL jos löytyy
    const urlH = getUrlHeight();
    if (typeof urlH === 'number') return urlH;

    // 3) jos URL:ssa on param mutta parsing epäonnistui -> käytä storage/hidden
    if (urlHasHeightParam()) {
      const s = getStoredHeight();
      if (typeof s === 'number') return s;
      const h = getHiddenHeight();
      if (typeof h === 'number') return h;
    }

    // 4) jos ei paramia -> ei filtteriä
    return null;
  }

  function syncUi() {
    const height = getEffectiveHeight();

    // jos filtteriä ei ole URL:ssa, varmistetaan että myös storage tyhjenee
    if (!urlHasHeightParam() && pendingValue === undefined && typeof height !== 'number') {
      setStored(null);
      setHidden(null);
      stickySetVisibleValue(null);
      showClearButton(false);
      updateApplyButtonState();
      return;
    }

    setHidden(height);

    if (typeof height === 'number') {
      stickySetVisibleValue(height);
      showClearButton(true);
    } else {
      stickySetVisibleValue(null);
      showClearButton(false);
    }

    updateApplyButtonState();
  }

  async function applyHeight() {
    const input = $('height-finder-input');
    if (!input) return;

    const digits = sanitizeDigits(input.value);
    const height = parseInt(digits, 10);

    if (!digits) return showError('Anna pituus (cm)');
    if (digits.length !== AUTO_APPLY_DIGITS) return showError('Anna 3 numeroa (cm)');
    if (Number.isNaN(height)) return showError('Anna numero');
    if (height < MIN_ALLOWED) return showError(`Minimipituus on ${MIN_ALLOWED} cm`);
    if (height > MAX_ALLOWED) return showError(`Maksimipituus on ${MAX_ALLOWED} cm`);

    clearError();

    pendingValue = height;   // lukitse UI heti tähän
    setStored(height);
    setHidden(height);
    stickySetVisibleValue(height);
    showClearButton(true);

    updateApplyButtonState(); // disabled while pending

    const seq = ++opSeq;

    const kicked = triggerFacetsAjaxRefresh();
    if (!kicked) {
      fallbackNavigateTo(height);
      return;
    }

    const updated = await waitForFacetUpdate();
    if (seq !== opSeq) return;

    // jos teema ei päivitä URL:ia, fallback
    if (!updated && !urlMatchesExpected(height)) {
      fallbackNavigateTo(height);
      return;
    }

    pendingValue = undefined;
    syncUi();
  }

  async function clearHeight() {
    clearError();

    pendingValue = null; // lukitse UI tyhjäksi
    setStored(null);
    setHidden(null);
    stickySetVisibleValue(null);
    showClearButton(false);

    updateApplyButtonState(); // disabled while pending

    const seq = ++opSeq;

    const kicked = triggerFacetsAjaxRefresh();
    if (!kicked) {
      fallbackNavigateTo(null);
      return;
    }

    const updated = await waitForFacetUpdate();
    if (seq !== opSeq) return;

    if (!updated && !urlMatchesExpected(null)) {
      fallbackNavigateTo(null);
      return;
    }

    pendingValue = undefined;
    syncUi();
  }

  // Clear-nappi (oma) + muut clear-toiminnot
  function onDocumentClick(e) {
    const clearBtn = e.target.closest('#height-finder-clear');
    if (clearBtn) {
      e.preventDefault();
      clearHeight();
      return;
    }

    // Tyhjennä kaikki
    const t = (e.target && e.target.textContent) ? e.target.textContent.trim() : '';
    const isClearAll = /Tyhjennä kaikki/i.test(t);

    if (isClearAll) {
      setStored(null);
      pendingValue = undefined;
      return;
    }

    // Aktiivisen filtterin chip-poisto
    const stored = getStoredHeight();
    if (typeof stored === 'number') {
      const chip = e.target.closest('facet-remove, .active-facets__button, .active-facets__button-inner, .facets__selected, .facet-remove');
      if (chip) {
        const chipText = (chip.textContent || '').trim();
        if (chipText.includes(String(stored))) {
          setStored(null);
          pendingValue = undefined;
        }
      }
    }
  }

  function installObserver() {
    const target = getFacetRoot() || document.body;

    const obs = new MutationObserver(() => {
      ensureHiddenInput();
      bindHeightInputGuards();
      ensureApplyButton();
      ensureStyles();
      syncUi();
    });

    obs.observe(target, { childList: true, subtree: true });
    return obs;
  }

  // Init
  ensureStyles();
  ensureHiddenInput();
  bindHeightInputGuards();
  ensureApplyButton();

  syncUi();
  installObserver();

  document.addEventListener('click', onDocumentClick, true);

  window.addEventListener('popstate', () => {
    pendingValue = undefined;
    syncUi();
  });

  window.addEventListener('pageshow', () => {
    pendingValue = undefined;
    syncUi();
  });

  document.addEventListener('shopify:section:load', () => {
    pendingValue = undefined;
    syncUi();
  });
})();
